<template>
  <div>
    <!--    <div style="background-color: rgb(232,232,232);">-->
    <!--      <div class="row m-0 col-10 mx-auto">-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button"><router-link to="/mans">-->
    <!--            Работники-->
    <!--          </router-link></span>-->
    <!--        </div>-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button">-->
    <!--            Отчеты-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <div class="col text-center p-4">-->
    <!--          <span class="nav-button"><a @click="back">-->
    <!--            Назад в Доставку-->
    <!--          </a></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="logo">-->
    <!--      <h2>Курьеры</h2>-->
    <!--      <router-link to="/mans">-->
    <!--        <button>Работники</button>-->
    <!--      </router-link>-->
    <!--      <button>Отчеты</button>-->
    <!--      <button @click="back()">Назад в Доставку</button>-->
    <!--    </div>-->

    <div class="logo">
      <h2>Курьеры</h2>
      <button @click="showComponent('DeliveryMans', true)">Работники</button>
      <button>Отчеты</button>
      <button @click="back()">Назад в Доставку</button>
      <button v-if="currentComponent === 'DeliveryMans'" @click="showComponent('DeliveryManAdd')"
              style="margin-left: auto;">
        Добавить Работника
      </button>
      <button v-if="lastComponent != null" @click="showComponent(lastComponent, true)"
              style="margin-left: auto;">
        Назад
      </button>
    </div>

    <!--    <keep-alive>-->
    <component v-bind:is="currentComponent"></component>
    <!--    </keep-alive>-->

<!--    <div class="fixed-bottom">-->
<!--      <div class="p-2">-->
<!--        <b>merchantHash is</b> {{ $store.state.merchantHash }}-->
<!--      </div>-->
<!--      <div class="p-2">-->
<!--        <b>restId is</b> {{ $store.state.restId }}-->
<!--      </div>-->
<!--      <div class="p-2">-->
<!--        <b>orderId is</b> {{ $store.state.orderId }}-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Home from './components/Home';
import DeliveryMans from './components/DeliveryMans';
import DeliveryManAdd from './components/DeliveryManAdd';
import Action from './components/Action';

export default {
  name: 'App',
  props: ['merchantHash', 'restId', 'orderId'],
  components: {
    Home,
    DeliveryMans,
    DeliveryManAdd,
    Action,
  },
  data() {
    return {
      currentComponent: null,
      lastComponent: null,
    };
  },
  created() {
    this.$store.commit('updateRestInfo', {
      merchantHash: this.merchantHash,
      restId: this.restId,
      orderId: this.orderId,
    });
    if (this.orderId == null) {
      this.currentComponent = 'Home';
    } else {
      this.currentComponent = 'Action';
    }
  },
  methods: {
    back() {
      history.back();
    },
    showComponent(componentToShow, hasToNull = false) {
      if (hasToNull) {
        this.lastComponent = null;
      } else {
        this.lastComponent = this.currentComponent;
      }
      this.currentComponent = componentToShow;
    },
  },
};
</script>

<style>
  @font-face {
    font-family: Inter;
    src: url(./assets/fonts/Inter-Medium.woff) format('woff'), url(./assets/fonts/Inter-Medium.ttf) format('truetype');
  }

  body {
    font-family: Inter;
    padding: 0 40px;
    background-color: #F8F9FB;
  }

  .nav-button {
    background: #97c8aa;
    border-radius: 4px;
    color: white;
    font-size: 1.2rem;
    padding: 1rem 0;
    display: block;
  }

  .nav-button-active {
    background: #27BB62;
    border-radius: 4px;
    color: white;
    font-size: 1.2rem;
    padding: 1rem 0;
    display: block;
  }

  .nav-button:hover {
    background: #27BB62;
    border-radius: 4px;
    color: white;
    cursor: pointer;
  }

  a {
    color: white;
    text-decoration: none;
  }

  a:hover {
    color: white;
    text-decoration: none;
  }

  .own-list-item {
    padding: 2rem;
    font-weight: bold;
  }

  .mb {
    border: 2px solid #E3E7EC;
    padding: 7px 16px;
    background: #E3E7EC;
    border-radius: 4px;
    line-height: 18px;
    font-size: 15px;
    text-decoration: none;
    color: #7E8A97;
  }

  input {
    height: 45px;
    border: none;
    background: #E3E7EC;
    border-radius: 4px;
    width: 100%;
    margin: 8px 0;
    /*font-weight: 600;*/
    padding-left: 8px;
  }

  .logo {
    margin-top: 15px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
  }

  /*.logo button{*/
  /*  padding: 12px 18px;*/
  /*  background: #27BB62;*/
  /*  border-radius: 4px;*/
  /*  font-size: 16px;*/
  /*  !*font-weight: 600;*!*/
  /*  color: white;*/
  /*  text-decoration: none;*/
  /*  margin-left: 15px;*/
  /*  !* margin-bottom: 15px;*!*/
  /*}*/

  .logo button {
    padding: 12px 18px;
    background: #27BB62;
    border: none;
    outline: none;
    border-radius: 4px;
    font-size: 16px;
    /*font-weight: 600;*/
    color: white;
    text-decoration: none;
    margin-left: 15px;
    /* margin-bottom: 15px;*/
  }

  .logo h2 {
    margin: 0;
    font-size: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/Couriers.vue